import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { NavController, NavParams, ModalController, IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { GrupoProvider } from "src/app/services/grupo/grupo";
import { ChartData, ChartOptions, ChartType, ChartDataset } from "chart.js";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgChartsModule } from "ng2-charts";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

@Component({
  selector: "app-grupo-adm-grafico",
  templateUrl: "./grupo-adm-grafico.page.html",
  styleUrls: ["./grupo-adm-grafico.page.scss"],
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule, NgChartsModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GrupoAdmGraficoPage implements OnInit {
  idGrupo: string;
  barChartType: ChartType = "bar";
  barChartData: ChartData<"bar"> = { labels: [], datasets: [] };
  barChartOptions: ChartOptions = {};

  pieChartType: ChartType = "pie";
  pieChartData: ChartData<"pie"> = { labels: [], datasets: [] };
  pieChartOptions: ChartOptions = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private translate: TranslateService,
    public grupoProvider: GrupoProvider,
    public modalCtrl: ModalController
  ) {
    this.idGrupo = this.navParams.get("idGrupo");

    this.barChartOptions = {
      responsive: true,
      plugins: {
        title: {
          display: true,
          text: this.translate.instant("Histórico de Frequência"),
        },
        legend: {
          position: "bottom",
          labels: {
            usePointStyle: true,
            pointStyle: "rectRounded",
          },
        },
      },
    };

    this.pieChartOptions = {
      responsive: true,
      plugins: {
        title: {
          display: true,
          text: this.translate.instant("Faixa Etária dos Participantes"),
        },
        legend: {
          position: "bottom",
            labels: {
            usePointStyle: true,
            pointStyle: "rectRounded",
          },
        },
      },
    };
  }

  ngOnInit() {
    this.grupoProvider.grupoGrafico(this.idGrupo).subscribe((data) => {
      this.calcBar(
        data.frequencia.data,
        data.frequencia.presentes,
        data.frequencia.visitantes,
        data.frequencia.ausentes,
        data.frequencia.esporadicos,
        data.frequencia.inativos
      );
      this.calcPie(data.etaria);
    });
  }

  calcBar(
    datas: string[],
    presentes: number[],
    visitantes: number[],
    faltantes: number[],
    esporadicos: number[],
    inativos: number[]
  ) {
    const formattedDates = datas.map((d) => format(parseISO(d), "dd-MMM", { locale: ptBR })).reverse();

    this.barChartData = {
      labels: formattedDates,
      datasets: [
        {
          data: presentes.reverse(),
          label: this.translate.instant("Presentes"),
          backgroundColor: "rgba(66, 139, 255)",
          borderRadius: {
            topLeft: 10,
            topRight: 10,
            bottomLeft: 0,
            bottomRight: 0,
          },
          borderSkipped: false,
        },
        {
          data: visitantes.reverse(),
          label: this.translate.instant("Visitantes"),
          backgroundColor: "rgba(45, 235, 127)",
          borderRadius: {
            topLeft: 10,
            topRight: 10,
            bottomLeft: 0,
            bottomRight: 0,
          },
          borderSkipped: false,
        },
        {
          data: faltantes.reverse(),
          label: this.translate.instant("Faltantes"),
          backgroundColor: "rgba(237, 47, 47)",
          borderRadius: {
            topLeft: 10,
            topRight: 10,
            bottomLeft: 0,
            bottomRight: 0,
          },
          borderSkipped: false,
        },
        {
          data: esporadicos.reverse(),
          label: this.translate.instant("Esporadicos"),
          backgroundColor: "rgba(252, 186, 3)",
          borderRadius: {
            topLeft: 10,
            topRight: 10,
            bottomLeft: 0,
            bottomRight: 0,
          },
          borderSkipped: false,
        },
      ],
    };
  }

  calcPie(etaria: number[]) {
    this.pieChartData = {
      labels: [
        this.translate.instant("De 0 à 12 anos"),
        this.translate.instant("De 13 à 18 anos"),
        this.translate.instant("De 19 à 35 anos"),
        this.translate.instant("De 36 à 65 anos"),
        this.translate.instant("De 66 ou mais"),
      ],
      datasets: [
        {
          data: etaria,
          backgroundColor: [
            "rgba(66, 139, 255)",
            "rgba(45, 235, 127)",
            "rgba(237, 47, 47)",
            "rgba(252, 186, 3)",
            "rgba(103, 3, 252)",
          ],
        },
      ],
    };
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
